export default {
    title: '商业孵化器',
    home: {
        theme: '',
        advantage: [
            '提供高效、安全、合规的解决方案, 赋能实体经济数字化转型',
            '赋能实体经济数字化转型',
        ],


        core: {
            title: 'BIT三大核心举措',
            open: {
                title: '开源',
                content: '培养开源社区，促进强大的金融产品和服务网络的发展，帮助人们更好的访问和使用BIT网络。',
            },
            decent: {
                title: '去中心化',
                content: '通过添加更多节点来扩大BIT网络。',
            },
            pledge: {
                title: '质押',
                content: '通过提供补助金、开源参考实现和社区支持来促进权益质押。',
            },
        },
        statistic: {
            title: 'BIT公链数据',
            accountCount: 'BIT上激活账户总数',
            transactionCount: 'BIT上记录的交易总数',
            voteCount: 'BIT生态上票权数',
            tokenCount: 'BIT代币转账总价值',
            accountCount2: 'BIT发行总量',
            liutong: 'BIT流通总量',
            transactionCount2: 'BIT上节点总数',
            voteCount2: 'BIT上质押总量',
            tokenCount2: 'BIT出块奖励总量',  
            stakeCount: 'BIT上质押奖励总量',
        },
        statisticCount: {
            node: '节点',
            contract: '总合约',
            token: '总代币',
        },
        stakingdata: {
            title: 'BIT质押数据',
        },
        market : {
            title: '加密货币市场',
        },
        globalpoint: {
            title: '全球节点',
            title2: '全球节点列表',
            search_title: '默认按BIT节点票数降序排列',
            search_icon: '按节点账户/排名搜索',
            item1: '排名',
            item2: '节点账户',
            item3: '票数(24H)',
            item4: '出块高度',
            global_title: '随时随地，便捷交易',
            download: '扫码下载',
            rule: '节点挖矿产出规则',
        },
        member: {
            title: '共识者风采',
            annie: {
                name: 'Annie',
                position: '新加坡BIT基金会理事',
                describe: '负责基金会常务事宜和BIT代币管理',
            },
            lin: {
                name: 'Lin',
                position: '新加坡BIT基金会副理事',
                describe: '负责协助理事日常工作',
            },
            tommy: {
                name: 'Tommy',
                position: '香港区块链技术应用协会 理事',
                describe: '香港乾元比特 首席执行官',
                describe1: '拥有超过10年的行业经验，是一位在数字化转型和区块链技术领域具有深厚造诣的专家',
            },
            lucius: {
                name: 'Lucius',
                position: '金融架构师及数据分析师',
                describe: '从事金融业及区块链行业超10年经验，累计运营服务多个区块链项目，包含2个公链项目',
            },
            mark: {
                name: 'Mark',
                position: '国家高级软件工程师和系统架构师',
                describe: '曾主导过多个大型软件项目和区块链解决方案',
            },
            oxf: {
                name: '0xF',
                position: '商业孵化器(BIT)网络CTO',
                describe: '新加坡BIT基金会成员',
            },
            oxhi: {
                name: '0xHi',
                position: '商业孵化器(BIT)网络实验室',
                describe: '新加坡BIT基金会成员',
            },
        },
        future: {
            title: 'BIT未来规划路线图',
            time:['2022.05','2023.08', '2024.10','2024.11', '2024.12', '2025.05','2025.08','2025.10','2025.11','2026.03','2026.10','2027.05','2028.03','2029.10'],
            content1: 'BIT Network项目正式启动，核心开发团队组建完毕。我们完成了底层技术选型与架构设计，开始编写核心协议代码，为未来的智能网络时代奠定坚实的理论基础与技术根基。',
            content2:'BIT Network迈出关键一步，启动源生社区建设。我们通过多种渠道吸引早期开发者与区块链爱好者加入，共同探讨生态未来，凝聚社区共识，为项目的长期发展注入活力。',
            content3:'Network主网正式启动，标志着BIT智能网络时代全面开启。主网上线意味着我们拥有了独立、安全、高效的区块链网络，为后续所有生态应用提供核心支撑。',
            content4:'主网上线后一个月，即2024年11月，BIT通证正式登陆交易所开放交易。这一举措提供了初始流动性，让更广阔的市场能够参与并评估BIT网络的价值。',
            content5:'BIT跨链桥接服务准时上线。它成功打通了BIT网络与BNB Chain等其他主流公链的资产流通通道，实现了多链互联，极大地拓展了生态边界。。',
            content6:'生态核心去中心化交易所BITSwap启动建设。它将为网络内原生资产提供便捷的兑换与流动性挖矿服务，成为BIT DeFi生态体系的流量与价值交换枢纽。',
            content7:'，BIT Network迎来重要里程碑，成功实现首批RDA（真实世界数据资产）企业上链。此举将传统金融资产引入区块链，开启了资产数字化的新篇章，彰显了其实用价值。',
            content8:'BIT Network全面拥抱开源，向全球开发者公开核心代码。同时，网络节点正式启动并开始产出激励，标志着去中心化治理与社区共治进入新阶段。',
            content9:'BIT Network将举办首次全球线上推广发布会，向全世界展示项目成果、技术优势与未来愿景。此举旨在提升全球影响力，吸引更多合作伙伴与用户。',
            content10:'BIT Network将启动首届全球黑客松大赛。我们将以丰厚奖金激励全球优秀开发者在我们的公链上构建创新应用，繁荣生态，发掘下一代杀手级DApp。',
            content11:'生态应用将持续突破，链上商城与集成化社交工具流上线。它们将区块链技术与日常应用场景结合，为用户提供了全新的Web3体验，丰富了生活方式。',
            content12:'BIT Network计划实现“百家企业上链”的宏伟目标。众多企业将在我们的网络上部署了各类商业应用，证明了BIT网络的技术成熟度与商业吸引力。',
            content13:'团队将启动全球巡回路演，足迹遍布世界主要金融科技中心。同期，BIT通证计划成功登陆全球顶级加密货币交易所，获得了前所未有的流动性与市场认可度。',
            content14:'2029年10月，BIT Network初始节点奖励周期圆满结束。我们计划开启更为宏大的第二阶段，并着手制定下一个七年的发展蓝图，迈向一个完全成熟、自治的生态系统。',
            
        },
        BITdonate: {
            title: 'BIT捐赠计划',
            title2: '支持BIT网络',
            content4: 'BIT基金会,用于留守儿童助学成长计划。',
        },
        RWAcooperate: {
            title: 'RDA企业合作伙伴',
        },
    },
    tablehaead: {
        item1: '代币',
        item2: '价格',
        item3: '流通量',
        item4: '流通总量',
        item5: '流通市值',
        item6: '总市值',
        item7: '24H交易量',
        item8: '涨跌幅',
    },
    
   
    ecology: {
        title: 'BIT六大生态',
        theme: ['多维融合',
            '重塑RDA生态价值网络'
        ],
        advantage: [
            '基于BIT EVM技术构建',
            '驱动全球RDA价值合作新时代',
        ],

        pledge: {
            name: '质押',
            title: 'BIT 质押',
            describe: '公开、透明、全部在链上',
            ex: [
                {
                    title: '参加选举投票',
                    describe: ['BIT网络的原生代币 BIT 持有者可以质押获得 BIT Power，用于链上选举投票，得票最多的 19 名候选人将作为 BIT网络 的见证人负责出块和打包交易。']
                },
                {
                    title: '保护网络',
                    describe: ['BIT网络是一个 DPoS 网络，其中超级代表(SR)负责记录和验证交易。如果 SR 效率低下或不可用，选民可以将选票转移到更好的节点以确保网络安全。']
                },
                {
                    title: '分享区块奖励',
                    describe: ['BIT网络设计了激励模型来保证区块链的安全性和效率，成功出块的见证人会得到 BIT 奖励，并按照设定的比例分配给投票者。']
                },
            ],
            quantityReward: {
                title: '计算你的质押奖励',
                pledge: '我想质押',
                reward: '美国东部时间，奖励',
                tips: '* 此处估算的BIT奖励是根据所选的质押期限和输入的BIT数量计算得出的。实际APY和BIT奖励可能会有所不同。',
                btn: '立即质押 →',
            },
        },
        wallet: {
            name: '钱包',
            title: 'BIT 钱包',
            describe: '专为BIT网络上所有“通证”提供存储和各项生态的链接',
            ex: [
                {
                    title: '管理BIT数字资产',
                    describe: ['数字资产管理是BIT钱包最基础也是最核心的功能，相比于数字资产分布在各个分散的平台，BIT钱包能够聚合用户的数字资产，进行统一管理，当然最重要的是提升了数字资产的安全性。']
                },
                {
                    title: '登录去中心化应用程序（DAPP）',
                    describe: ['允许用户与去中心化应用程序进行交互。这些应用程序通常基于以区块链技术构建，具有去中心化、透明和不可篡改的特点，用户可以使用钱包登录并使用DApp，大大提升了用户的使用体验和效率，同时BIT钱包还起到了数字资产流通的桥梁作用。']
                },
                {
                    title: '身份验证',
                    describe: ['BIT钱包还可以用于管理用户的身份信息。用户可以使用钱包进行身份验证，并在需要时共享他们的身份信息。这可以用于各种用途，例如在线投票、数字身份证明、KYC（了解你的客户）等。']
                },
            ],
            quantityReward: {
                // title: '计算你的质押奖励',
                // pledge: '我想质押',
                // reward: '美国东部时间，奖励',
                // tips: '* 此处估算的BIT奖励是根据所选的质押期限和输入的BIT数量计算得出的。实际APY和BIT奖励可能会有所不同。',
                btn: '查看你的数字资产→',
            },
        },
        scan: {
            name: '区块浏览器',
            title: 'BIT 区块浏览器',
            describe: 'BIT区块浏览器从设计上是透明的，所有信息都可以验证',
            ex: [
                {
                    title: '执行数据',
                    describe: ['执行数据是指已在一个特定区块内执行的交易。每隔3秒就会有新的区块被添加到BIT区块浏览器（除非区块提议者错过了提议机会），因此有几近稳定的数据流被添加到区块浏览器中。']
                },
                {
                    title: '共识层数据网络',
                    describe: [
                        '共识层最高层数据包括以下内容：',
                        '· 当前时段',
                        '· 当前时隙',
                        '· 活跃验证者 - 活跃验证者的数量',
                        '· 待定验证者 - 等待激活的验证者数量',
                        '· 质押的BIT - 网络中质押的BIT金额',
                    ]
                },
            ],
        },
        swap: {
            name: '去中心化交易所',
            title: 'BIT 去中心化交易所',
            describe: 'BIT去中心化交易所（DAPP）是在去中心化网络上构建，结合智能合约和旗下各生态前端界面',
            ex: [
                {
                    title: '去中心化',
                    describe: ['在BIT网络上运行，这是一个开放的公共去中心化平台，没有任何一个人或团体可以控制']
                },
                {
                    title: '去信任的计算/可验证的行为',
                    describe: ['BIT智能合约可以分析并保证以可预测的方法执行，而去信任中心化组织']
                },
                {
                    title: '数据完整性',
                    describe: ['由于采用了加密基元，存储在区块链上的数据是不可更改和无可争议的。恶意行为者无法伪造已经公开的交易或其他数据']
                },
                {
                    title: '抵制审查',
                    describe: ['网络上没有任何一个实体可以阻止用户提交交易、部署dapp或读取区块链上的数据']
                },
                {
                    title: '隐私',
                    describe: ['客户不需要提供真实世界的身份来部署或与dapp进行交互']
                },
                {
                    title: '零停机时间',
                    describe: ['智能合约部署到BIT网络上，整个网络都能为那些希望与合约互动的客户提供服务。因此，恶意参与者无法针对单个dapp发起']
                },
            ],
        },
        nft: {
            name: 'NFT',
            title: 'BIT 非同质化代币（NFT）',
            describe: 'BIT非同质化代币(NFT)正在前所未有地向内容创作人赋予更多权利',
            ex: [
                {
                    title: 'BIT非同质化代币(NFT)用途',
                    describe: [
                        '· 证明你参加过某个活动',
                        '· 证明你完成了某个课程',
                        '· 在游戏中拥有的物品',
                        '· 数字艺术',
                        '· 将实体资产代币化',
                        '· 证明你的线上身份',
                        '· 限制内容访问权限',
                        '· 发放凭据',
                        '· 分布式互联网域名',
                        '· 在去中心化金融中作为抵押品',
                    ]
                },
            ],
            detailDescribe: '假设你是一位艺术家，希望使用NFT分享自己的作品，同时不想失去对作品的控制，也不想中间商分走利润。 你可以创建个新合约，指定NFT的数量、属性和特定艺术品的链接。 作为艺术家， 你可以在智能合约中设置你应该收取的版税(例如：每次转让NFT时，将销售价格的5%转给合约所有人) 因为你拥有部署合约的钱包，所以你始终可以证明你是NFT的创建者。 你的买家也可以轻松地证明他们拥有代表你的系列艺术品的真正的NFT，因为他们的钱包地址与你的智能合约中的一个代币相关联。 他们可以在整个BIT生态系统中使用该NFT，因为其真实性能得到保证。'
        },
        community: {
            name: '社区',
            title: 'BIT 社区超级代表',
            describe: '在BIT网络上，所有BIT持有者都可以申请成为SR候选人，并有机会成为SR或SR合伙人。',
            ex: [
                {
                    title: '执行数据',
                    describe: ['执行数据是指已在一个特定区块内执行的交易。每隔3秒就会有新的区块被添加到BIT区块浏览器（除非区块提议者错过了提议机会），因此有几近稳定的数据流被添加到区块浏览器中。']
                },
                {
                    title: '',
                    describe: [
                        '任何BIT持有者都可以投票给SR候选人，其中得票数排名前19位的候选人将成为SR，而第20至第119位的候选人将成为SR合伙人。',
                        'SR负责生产区块和打包交易，并获得投票奖励和区块奖励;SR合伙人则只获得投票奖励，不承担上述两个任务。',
                        '所有 SR 候选人、SR 合伙人以及 SR 都有权发起修改 BIT 网络参数的提案。',
                    ]
                },
            ],
            quantityReward: {
                // title: '计算你的质押奖励',
                // pledge: '我想质押',
                // reward: '美国东部时间，奖励',
                // tips: '* 此处估算的BIT奖励是根据所选的质押期限和输入的BIT数量计算得出的。实际APY和BIT奖励可能会有所不同。',
                btn: '申请成为BIT候选人→',
            },
        },
    },
    point: {
        
        title: '真正的权利和权益的获取',
        title2: '从参与运行一个节点开始',
        describe: '从被动的网络使用者，变为主动的共建与共享者',
        describe2: '获取收益，享有投票权，真正掌握自己的数字命运',
        
    },
    contribute: {
        theme1: '真实世界数据资产（RDA）',
        theme2: '链上新基石',
        advantage: '告别波动，获取由实体资产支撑的稳健收益',
        advantage2: '在BIT，率先拥抱下一波企业数字化变革的浪潮',
        module1: {
            // title: '生态系统资助计划',
            title: 'BIT旗下生态',
            describe: 'BIT网络生态系统内的团队运营着许多资助计划。通常，这些计划专注于特定的垂直领域，以满足特定申请人的需求。以下生态系统团队运营着自己的资助计划。',

            product: [
                {
                    title: 'MAX(无极限)',
                    describe: 'MAX(无极限)是由新加坡红杉基金会发起，以区块链哈希值为判断依据的一款众筹、竞技、抵押借贷协议为一体的数字化产品。',
                },
                {
                    title: 'TC(天池)',
                    describe: '由新加坡红杉基金会联合BIT网络共同打造的去中心化交易所 —— “天池”。是BIT公链生态集群中，专为BIT网络上所有生态通证提供的交易场所。其他链上通证亦可来此进行交易',
                },
                {
                    title: 'PROJECT A(A计划)',
                    describe: '由5A基金会联合BIT网络共同打造,通过投资BIT代币和USDT获得每日释放的TVL收益，用户可通过定向推荐和发展社区来获得高额收益',
                },
                {
                    title: 'MOBIUS BAND(莫比乌斯环)',
                    describe: 'MOBIUS BAND(莫比乌斯环)是BIT网络生态旗下一款抽取盲盒赚取收益类区块链游戏。旨在支持 BIT DAO 建设者在治理工具、安全性、代币化等方面进行创新',
                },
                {
                    title: 'BUARES(百U战神)',
                    describe: 'BIT网络生态联合TON基金会打造的一款完全去中心化链上创富计划，旨在推动USDT百倍增值，以及USDT达到最大可提取价值(MEV)',
                },
                {
                    title: 'PHOENIX(凤凰)',
                    describe: 'phoenix(风凰)是BIT网络生态对中国区块链市场的首次尝试，其目的是支持面向日常用户的 BIT网络 项日，提供资金以及营销支持并提高 BIT网络 生态系统内的知名度',
                },
                {
                    title: '链话西游',
                    describe: '这是BIT公共网络推出的一款以《西游》为主题的链游应用，在获得完整NFT的同时享受相应的权益。又能通过娱乐的方式让更多人了解西游文化，并传播到WEB3.0行业中，传播到全世界。',
                },
                {
                    title: '链多多',
                    describe: '天干地支来相会，一链星辰好事多。这是一款由BIT公共网络为企业提供，可用于促进商品销售的公用平台。用户亦可通过此方式，获得商品的同时，享受相对应的收益。',
                },
                {
                    title: '鹊桥',
                    describe: '鹊桥跨链桥，以零知识证明技术为核心，实现多链资产与数据快速互通，安全高效，适配 DeFi、NFT 等场景，为用户打造流畅跨链体验。',
                },
                {
                    title: 'WEB 3.0 手机',
                    describe: 'web3.0 手机集成去中心化钱包与 DApp 生态，支持多链交互，搭载硬件加密芯片保障资产安全，助用户畅享链上社交、DeFi，开启便捷 web3.0 生活。',
                },
                {
                    title: 'BIT deepseek',
                    describe: 'BIT deepseek基于先进大模型技术，具备高效推理与学习能力，支持多模态交互，广泛应用于智能办公、内容创作等场景，为用户提供智能高效解决方案。',
                },
                {
                    title: 'BIT kimi',
                    describe: 'Kimi 依托自研大模型，支持 200 万字超长上下文，擅长多格式文件处理与编程辅助，覆盖学术、创作等场景，提供智能高效的 AI 解决方案。',
                },
            ]
        },
        module2: {
            title: '社区公共产品资助',
            describe: 'BIT网络生态系统是一个活跃且不断变化的社区，有许多社区计划也为BIT生态系统内的公共产品提供资金。示例包括：',
            product: [
                {
                    title: 'SENTINEL（哨兵计划）',
                    describe: 'SENTINEL（哨兵计划）通过社区选出的代表来资助有影响力的公共物品，代表们对项目的影响进行投票，并相应地从配套池中分配资金。',
                },
            ]
        }
    },
    server: {
        theme: '真正的权力下放 从运行一个节点开始',
        advantage: '通过与世界顶级数据中心提供商签订按月合同访问可用于验证器的服务器,此可选计划使去中心化系统运营商能够访问通常为大型组织保留的硬件',
        plan: {
            title: '关于此计划',
            content: [
                '优质的服务器是网络运营的关键组成部分。然而，个人有时很难获得新服务器。因此，BIT网络基金会代表BIT网络验证者社区与世界各地的多家数据中心提供商合作，以灵活的按月合同向BIT生态系统提供服务器租赁服务。',
                '该可选程序旨在促进验证者和BIT网络社区的可持续发展，并进一步去中心化BIT网络。',
            ]
        },
        run: {
            title: '整个进程如何运作？',
            content: [
                '使用上方的“在此注册”按钮注册该计划。此时将提示个人完成 KYC（“了解您的客户”）流程。KYC流程是参与该计划的必要条件。',
                '符合条件的个人将收到一封欢迎电子邮件和服务器计划协议（SPA），这些协议将发送到所提供的电子邮件中。',
            ]
        },
        problem: {
            title: '常见问题解答',
            content: [
                {
                    question: '服务器的价格是多少？',
                    answer: '注册该计划后，可以直接从适用的数据中心提供商处获得准确的服务器价格。',
                },
                {
                    question: '服务器规格是什么？',
                    answer: '所有服务器都经过了审核，以满足网络的长期需求。',
                },
                {
                    question: '注册并获得访问权限需要多长时间？',
                    answer: '从头到尾整个过程应该只需要几天时间，但最快也只需要一天。基金会试图让整个过程尽可能简单，以帮助个人及时获得基础设施。',
                },
                {
                    question: '如何计费？',
                    answer: '当您注册参与数据中心时，您将输入您的信用卡信息，并由服务器供应商按月计费。',
                },
                {
                    question: 'BIT基金会是否从该计划中通过硬件销售获利？',
                    answer: '不会。',
                },
            ]
        },
    },
    develop: {
        theme: 'BIT开发者指南',
        title: '助您技术启航',
        advantage: 'BIT Network 凭借精准定位、团队实力',
        advantage2: '和先发优势以及全球化的潜力,在RDA 赛道中占据领先地位',
        github: {
            title: '软件项目托管平台-Github',
            describe: 'BIT Network与GitHub深度集成，为开发者打造无缝的Web3构建体验。',
            describe2: '在您熟悉的GitHub环境中，既可以管理BITNetwork上的智能合约与DApp。您的每一次代码提交与协作，都能在链上转化为透明、可信的逻辑，构建坚实的信任基石。',
            describe3: 'BIT Network旨在将Github的开源活力，通过智能合约与通证经济，扩展为一个可持续的激励生态，赋能每一位开发者的创造。',
            describe4: '核心优势：',
            btn: '了解更多',
            advantage: '开发者友好：低级学习成本',
            advantage2: '安全可靠：代码透明可验证',
            advantage3: '生态激励：为开源贡献赋能',
        },
        redbook: {
            title: 'BITNetwork-红皮书',
            describe: 'BIT Network 是一条专注于现实世界数据资产（RDA）通证化的区块链基础设施，致力于将传统世界的资产通过证券化形式映射至链上，并为其提供高效的金融应用场景。',
            describe2: '该网络旨在构建一个连接传统金融（TradFi）与去中心化金融（DeFi） 的生态，通过模块化链设计（如 Optimistic Rollup 和 ZKRollup）支持高吞吐量的去中心化应用（dApp），强化资产流动性、可交易性和互操作性。BIT Network 还集成智能合约功能，使RDA资产能够嵌入借贷、质押、衍生品等多元化金融协议，为用户提供真实的收益机会和链上商业模式。',
            describe3: '通过赋能机构及生态合作伙伴，BIT Network力图打造一个兼具合规性、可扩展性和真实商业应用价值的下一代金融网络。',
            btn: '了解更多',
        },
        sdk: {
            title: 'BIT SDK-技术白皮书',
            describe: 'BIT SDK 是一套全面而强大的开发者工具集，旨在为BIT生态中原生应用与元服务的开发提供核心支持。它集成了包括生态框架、应用服务在内的丰富区块链开放能力，覆盖从账户管理、链交互到智能合约等关键模块。',
            describe2: '通过提供高效、安全且易用的开发组件，BIT SDK 极大地降低了技术门槛，使开发者能够专注于创新，快速构建和部署在DeFi、RDA等全场景下的高性能DApp。它是赋能开发者、推动BIT生态繁荣与大规模应用落地的关键技术基石。',
            btn: '了解更多',
        },
    },
    past: {

        title: '往届RDA峰会风采',
        content: 'BIT Network 2023年12月15日-16日，在上海举办了首届RDA峰会，展示了BIT Network在RDA领域的创新与实践。',
    },
    introduce: {
        title: 'RDA企业介绍',
        title1: '珩祥科技KW智链',
        content1: '珩祥科技作为中国智慧安全用电领军企业，携手Bit Network与RDA加速器，推出基于真实世界数据资产（RDA）的代币化战略。依托20万台在网AloT设备、百余项知识产权及高质量电气数据，公司将实体资产转化为可在全球流通的数字通证一KW通证，构建“资产运营＋金融服务” 新生态。此举旨在盘活数百亿沉睡资产，开辟低成本全球化融资渠道，打造电气安全领域的数字金融新标杆',
        title2: '艺链全球ACG智链',
        content2: '艺链全球是全球首个专注于中华艺术文化资产数字化的RDA平台，依托Bit Net-work高性能公链与RDA加速器合规通路，携手“一带一路王锁平国际艺术中心”，将顶级艺术品转化为可流通、可分割的数字资产。平台旨在破解艺术资产流动性困境，建立中华文化的全球定价权，并通过原生通证ACG构建“文化出海”的数字金融新范式，践行文化强国战略，开启中华艺术价值的全球化新纪元',
    },
   
    Configuration:{
        detail:['了解我们','下载应用'],
        pages: ['上一页','下一页']
    },
    nav: {
        menu: ['首页', '区块浏览器', '质押挖矿', '节点', 'RDA专区','开发者文档','新闻/通告'],
        bottom: ['BIT红皮书', '技术文档', '开源', '审计'],
    },
    footer: {
        content: ['关于我们', '隐私政策', '服务条款', '服务与支持', 'API', '联系我们', '资源', 'BIT架构', 'BIT 红皮书V2.0','技术白皮书V3.1.6'],
        right:'BIT区块链浏览器',
        download:'码上下载BIT wallet',
        c: 'Copyright© 2025-2028 All rights reserved.',



    },
    node: {
       
        content: '节点',
        content2: '国家 / 地区',
    },
    word: {
        title: '香港国际投资总会',
        content: '香港国际投资总会成立于2015年，是由中国国际商会投融委和明天更好基金会等发起，香港和内地金融投资界领袖组成，香港特区政府依法核准注册的机构。时任香港特区行政长官梁振英先生及中联办主任张晓明先生为该会荣誉赞助人。总会致力于推动跨境资本与产业创新融合，所服务项目覆盖金融科技、绿色能源、数字基建等领域，与香港证监会、香港金管局、香港财库局等机构保持深度政策协作',
    },
    word2: {
        title: '香港区块链技术应用协会',
        content: '香港区块链技术应用协会成立于2020年，是香港特区政府认可的行业权威机构，旨在联系香港、内地，以及东南亚中东、北美等地区块链技术及生态资源，聚焦区块链技术与实体经济场景结合，推动元宇宙的构建。协会联合 Coinstreet 等顶级机构，为企业提供数字化转型服务，实现跨境融资、数字资产分发一站式通路，并无缝对接东南亚、中东等新兴市场。',
    },
    word3: {
        title: '深圳市信息服务业区块链协会',
        content: '简称“深圳链协”2019年12月在深圳前海揭牌成立，是深圳市成立最早规模最大的市级区块链行业协会。全国政协常委第十二届全国人大常委、全国人大法律委副主任孙安民，全国政协常委、中国关心下一代工作委员会常务副主任、中央文明办原主任胡振民，中共深圳市委网信办副主任王远辉，深圳市社会组织党委专职副书记郭建，深圳市工信局信软处处长江雪明，央行深圳中心支行科技处处长周赞文，深圳市公安局网警支队党委委员孔令泊等为协会揭牌。',
    },
    word4: {
        title: '香港乾元比特投融资有限公司',
        content: '香港乾元比特投融资有限公司，总部位于国际金融中心香港，是一家专注于区块链技术与真实世界数据资产（RDA）融合领域的创新投融资机构。公司凭借对数字资产前沿的深刻洞察，致力于通过专业的资本赋能、全球化的资源整合以及严谨的合规架构，为全球范围内的优质创新项目提供全方位的资金支持与战略指导。我们的使命是搭建传统金融与数字未来的桥梁，积极驱动RDA生态的稳健成长与广泛应用，赋能实体经济的数字化未来。',

    },
    News: {
        title: 'BIT新闻快讯',
        title2: '感知生态脉搏',
        content: '深度聚焦BIT生态脉搏，洞察行业瞬息万变',
        content2: '我们的快讯，您的风向标',
    },
    accelerate: {
        title: 'RDA加速器',
        content: '香港RDA加速器是由香港区块链技术应用协会与香港国际投资总会联合发起的战略项目。它通过“资产上链+数据跨境+数据流通”的创新模式，构建了从境内资产数字化，到跨境数据流通，最终进入国际市场交易的全链条闭环，旨在为内地实体资产与全球资本市场搭建高效、合规的桥梁。',
        title2:'四大RDA加速器背书'
    },
    Detail:{ 
        back:'返回列表',
        previous:'上一篇',
        next:'下一篇',
        date:'发表日期',
        user:'文章作者'

    },
    NODE:{
        title:'节点数量',
        title2:'节点分布图',
        title3:'节点排名（按国家和地区）',
       
    }
    
}